module.exports = __webpack_public_path__ + "img/movie-main-top.2afdfbe8.png";